import { DataBean } from "../../DataBean";


export class HealthAttentionModality extends DataBean {


    public async getHealthAttentionModalityCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthAttentionModalityCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}